import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { IconButton, Icon, Stack, Tooltip } from "investira.react.components";
import { DataTable } from "../";
import { MRTToolbarActions } from "../../molecules";
import services from "../../../services";

/**
 * Renderiza o componente ArquivosDataGrid.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {Array} props.data - Propriedade `data` do componente.
 * @param {boolean} props.isFetching - Propriedade `isFetching` do componente.
 * @param {Object} props.initialState - Propriedade `initialState` do componente.
 * @param {*} props.onDeleteClick - Propriedade `onDeleteClick` do componente.
 *
 * @description
 * Este componente realiza as seguintes operacoes:
 * 1. Recebe as propriedades necessarias para compor a interface
 * 2. Organiza os estados e callbacks usados durante a renderizacao
 * 3. Renderiza a experiencia visual do organismo
 *
 * @returns {JSX.Element|null} Elemento renderizado pelo componente.
 */

const ArquivosDataGrid = (props) => {
  const { data, columns, ...restProps } = props;

  function onDownloadClick(pData) {
    if (pData) {
      services.posicoes.download(
        pData._rid,
        (rRes) => {
          let xOutputFilename = `${pData.arquivo}.xml`;

          if (rRes?.headers["content-disposition"]) {
            let xFilenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            let xMatches = xFilenameRegex.exec(
              rRes.headers["content-disposition"]
            );
            if (xMatches != null && xMatches[1]) {
              xOutputFilename = xMatches[1].replace(/['"]/g, "");
            }
          }

          const xFileURL = URL.createObjectURL(rRes.data);
          let xLinkElem = document.createElement("a");
          xLinkElem.href = xFileURL;
          xLinkElem.download = xOutputFilename;
          xLinkElem.click();
          URL.revokeObjectURL(xFileURL);
          xLinkElem.remove();
        },
        (rErr) => {
          console.log(rErr);
        }
      );
    }
  }

  const xProps = useMemo(() => {
    return {
      columns,
      ...restProps,
      enableFacetedValues: true,
      enableRowSelection: true,
      enableGlobalFilter: false,
      enableExpanding: false,
      enableFullScreenToggle: false,
      enableDensityToggle: false,
      enableBottomToolbar: true,
      muiTopToolbarProps: {
        sx: {
          backgroundColor: "none",
          alignItems: "center",
        },
      },
      renderToolbarInternalActions: ({ table }) => (
        <MRTToolbarActions table={table} />
      ),
      initialState: {
        ...props.initialState,
      },
      renderRowActions: ({ row }) => {
        return (
          <Stack direction="row">
            <Tooltip title="Download">
              <IconButton
                onClick={() => onDownloadClick(row.original)}
                color="primary"
              >
                <Icon iconName="download" size={21} />
              </IconButton>
            </Tooltip>
          </Stack>
        );
      },
    };
  }, [columns, props.initialState, restProps]);

  return <DataTable data={data} {...xProps} />;
};

ArquivosDataGrid.propTypes = {
  data: PropTypes.array,
  columns: PropTypes.array,
  isFetching: PropTypes.bool,
  initialState: PropTypes.object,
};

ArquivosDataGrid.default = {
  initialState: {},
};

export default ArquivosDataGrid;
